module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/1525bb90b40c8e7f354f22c39e0153ee.svg";